import SearchBox from "./search-box";
import TopicBox from "./topic-box";
export interface SearchBoxFilterProps {
  title: string;
  icon: string;
  onChange: (value: string) => void;
}
function SearchBoxFilter({ title, icon, onChange }: SearchBoxFilterProps) {
  return (
    <TopicBox title={title} icon={icon}>
      <SearchBox onChange={onChange} />
    </TopicBox>
  );
}

export default SearchBoxFilter;
